import React from 'react';

const AluminiHome = () => {
  return (
    <div className="min-h-screen bg-slate-50 p-3 md:p-6">
      <div className="mx-auto max-w-7xl rounded-xl p-4 md:p-6">
        <div className="mb-6 md:mb-8">
          <div className="flex items-center justify-between">
            <h1 className="mb-2 text-2xl font-bold text-slate-900 md:text-3xl">Alumni Dashboard</h1>
            <div className="flex items-center gap-2 md:gap-4">
              <div className="h-1.5 w-1.5 animate-pulse rounded-full bg-slate-600 md:h-2 md:w-2"></div>
              <span className="text-sm text-slate-600">Live</span>
            </div>
          </div>
        </div>

        <div className="mb-6 md:mb-8">
          <div className="flex items-center gap-1 overflow-x-auto rounded-xl border border-slate-200 bg-white p-1 shadow-sm">
            {['Overview', 'Analytics', 'Reports', 'Settings'].map((tab, index) => (
              <button
                key={tab}
                className={`flex items-center gap-2 whitespace-nowrap rounded-lg px-3 py-1.5 text-xs font-medium transition-all duration-200 md:px-4 md:py-2 md:text-sm ${
                  index === 0
                    ? 'bg-slate-900 text-white shadow-sm'
                    : 'text-slate-600 hover:bg-slate-100 hover:text-slate-900'
                }`}
              >
                {tab}
              </button>
            ))}
          </div>
        </div>

        <div className="space-y-4 md:space-y-6">
          <div className="rounded-xl border border-slate-100 bg-white p-4 shadow-sm md:p-6">
            <h3 className="mb-3 text-base font-semibold text-slate-900 md:mb-4 md:text-lg">
              Welcome Back!
            </h3>
            <p className="text-slate-600">
              Stay connected with your entrepreneurial journey and continue growing your network.
            </p>
          </div>

          <div className="grid grid-cols-1 gap-4 md:grid-cols-3 md:gap-6">
            {[
              { title: 'Network Connections', value: '247', icon: '👥' },
              { title: 'Mentorship Sessions', value: '12', icon: '🎓' },
              { title: 'Projects Completed', value: '8', icon: '✅' },
            ].map((stat, index) => (
              <div
                key={index}
                className="rounded-xl border border-slate-100 bg-white p-4 shadow-sm md:p-6"
              >
                <div className="mb-3 flex items-center justify-between md:mb-4">
                  <span className="text-xl md:text-2xl">{stat.icon}</span>
                  <span className="text-xs text-slate-500 md:text-sm">This month</span>
                </div>
                <div className="text-2xl font-bold text-slate-900 md:text-3xl">{stat.value}</div>
                <div className="mt-2 text-xs text-slate-600 md:text-sm">{stat.title}</div>
              </div>
            ))}
          </div>

          <div className="rounded-xl border border-slate-100 bg-white p-4 shadow-sm md:p-6">
            <h3 className="mb-3 text-base font-semibold text-slate-900 md:mb-4 md:text-lg">
              Recent Activity
            </h3>
            <div className="space-y-3 md:space-y-4">
              {[
                { action: 'Connected with', name: 'Sarah Johnson', time: '2 hours ago' },
                {
                  action: 'Completed mentorship session with',
                  name: 'Mike Chen',
                  time: '1 day ago',
                },
                { action: 'Joined', name: 'Innovation Workshop', time: '3 days ago' },
              ].map((activity, index) => (
                <div key={index} className="flex items-center justify-between">
                  <div className="flex items-center gap-2 md:gap-3">
                    <div className="flex h-6 w-6 items-center justify-center rounded-full bg-slate-100 md:h-8 md:w-8">
                      <span className="text-xs font-semibold text-slate-600 md:text-sm">
                        {activity.name.charAt(0)}
                      </span>
                    </div>
                    <div>
                      <p className="text-xs text-slate-900 md:text-sm">
                        {activity.action} <span className="font-semibold">{activity.name}</span>
                      </p>
                      <p className="text-[10px] text-slate-500 md:text-xs">{activity.time}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="mt-8 border-t border-slate-200 pt-6 md:mt-12 md:pt-8">
            <div className="rounded-xl border border-slate-100 bg-white p-4 shadow-sm md:p-6">
              <h3 className="mb-3 text-base font-semibold text-slate-900 md:mb-4 md:text-lg">
                Quick Actions
              </h3>
              <div className="grid grid-cols-2 gap-3 md:grid-cols-4 md:gap-4">
                {[
                  { title: 'Find Mentor', icon: '🎯', color: 'from-blue-50 to-blue-100' },
                  { title: 'Join Event', icon: '📅', color: 'from-green-50 to-green-100' },
                  { title: 'Share Story', icon: '📝', color: 'from-purple-50 to-purple-100' },
                  { title: 'Get Support', icon: '🤝', color: 'from-orange-50 to-orange-100' },
                ].map((action, index) => (
                  <button
                    key={index}
                    className="flex flex-col items-center rounded-lg bg-gradient-to-br from-slate-50 via-slate-200 to-slate-100 p-3 shadow-md transition-colors hover:bg-slate-200 md:p-4"
                  >
                    <span className="mb-1.5 md:mb-2">
                      <span className="h-5 w-5 text-slate-900 md:h-6 md:w-6">{action.icon}</span>
                    </span>
                    <span className="text-xs font-medium text-slate-900 md:text-sm">
                      {action.title}
                    </span>
                  </button>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AluminiHome;
